// extracted by mini-css-extract-plugin
export default {"host":"SelectInstance_host__jBXIr"};